/**
 * UI bridge (M1-18). B1 (net/world) WRITES the signals and SUBSCRIBES to the command bus;
 * B2 (Preact UI) READS the signals and DISPATCHES commands. No engine/Pixi imports here.
 */
import { signal } from '@preact/signals';
export function createBridge() {
    const handlers = new Set();
    const dispatch = (cmd) => {
        for (const h of [...handlers])
            h(cmd);
    };
    return {
        me: signal(null),
        needs: signal({ hunger: 100, energy: 100, hygiene: 100, fun: 100, social: 100 }),
        wallet: signal({ naira: 0 }),
        clock: signal({ day: 1, hour: 8 }),
        power: signal('grid'),
        chatLog: signal([]),
        bubbles: signal([]),
        mode: signal('world'),
        say: (text) => dispatch({ type: 'say', text }),
        chip: (id) => dispatch({ type: 'chip', id }),
        emote: (id) => dispatch({ type: 'emote', id }),
        interact: (targetId, verb) => dispatch(verb === undefined ? { type: 'interact', targetId } : { type: 'interact', targetId, verb }),
        openPhone: () => dispatch({ type: 'openPhone' }),
        onCommand(handler) {
            handlers.add(handler);
            return () => handlers.delete(handler);
        },
    };
}
